/**
 * Toggles the analytics provider's consent-aware mode. Resolved at bootstrap,
 * before React mounts, so it is read straight from the LaunchDarkly client
 * rather than through `useFeatureFlags`.
 */
export const CONSENT_ENABLED_FLAG_KEY =
  'configure-web-analytics-consent-enabled';

/**
 * Applied when LaunchDarkly does not resolve in time. Stays `true` because the
 * fallback for a flag failure can never be "track without consent" — turning
 * the gate off is always an explicit decision.
 */
export const DEFAULT_CONSENT_ENABLED = true;

/**
 * How long the analytics bootstrap may run before it is reported as degraded.
 * Purely an observability watchdog — nothing waits on it, so this is a "this is
 * definitely broken" threshold rather than a deadline the app pays for.
 */
export const ANALYTICS_BOOTSTRAP_TIMEOUT_MS = 10_000;

/** Logged when the analytics bootstrap rejects. Rendering is unaffected. */
export const ANALYTICS_BOOTSTRAP_FAILURE_MESSAGE =
  '[observability] Analytics bootstrap failed; the app is running without analytics.';

/**
 * Logged when the analytics bootstrap has neither resolved nor rejected within
 * `ANALYTICS_BOOTSTRAP_TIMEOUT_MS` — the provider promise is stuck. Rendering is
 * unaffected, so without this the degradation is invisible.
 */
export const ANALYTICS_BOOTSTRAP_TIMEOUT_MESSAGE = `[observability] Analytics bootstrap did not settle within ${ANALYTICS_BOOTSTRAP_TIMEOUT_MS}ms; the app is running without analytics.`;

/** Emitted when a user changes a table's column order. */
export const REORDER_COLUMNS_EVENT_NAME = 'Reorder columns';
